import controller from './header-core.controller';
import templateBase from './templates/header-core-base.view.html';
import templateT1 from './templates/header-core-t1.view.html';
import templateT2 from './templates/header-core-t2.view.html';
import templateT3 from './templates/header-core-t3.view.html';
import templateT4 from './templates/header-core-t4.view.html';
import templateT5 from './templates/header-core-t5.view.html';
import templateT6 from './templates/header-core-t6.view.html';
import templateT7 from './templates/template-t7.view.html';
import templateT10 from './templates/header-core-t10.view.html';
import templateT11 from './templates/header-core-t11.view.html';
import templateT12 from './templates/header-core-t12.view.html';
import templateT13 from './templates/header-core-t13.view.html';
import templateAD from './templates/header-adaptative.html';

let HeaderCoreComponent = {
  template: changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService','ngAuthSettings','SharedService','$rootScope'];

function changeTemplate(SessionService,ngAuthSettings,SharedService,$rootScope) {
  let response = SessionService.get('components');
  if(__env.adaptative){
    return templateAD;
  } else {
     if(response.HEADER.component == 'template_t1'){
      return templateT1
     }
     else if(response.HEADER.component == 'template_t2'){ return templateT2}
     else if(response.HEADER.component == 'template_t3'){ return templateT3}
     else if(response.HEADER.component == 'template_t4'){ return templateT4}
     else if(response.HEADER.component == 'template_t5'){ return templateT5}
     else if(response.HEADER.component == 'template_t6'){ return templateT6}
     else if(response.HEADER.component == 'template_t7'){ return templateT7}
     else if(response.HEADER.component == 'template_t10'){ return templateT10}
     else if(response.HEADER.component == 'template_t11'){ return templateT11}
     else if(response.HEADER.component == 'template_t12'){ return templateT12}
     else if(response.HEADER.component == 'template_t13'){ return templateT13}
     else{
      return templateBase;
     }
  }
}

export default HeaderCoreComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/header-core/header-core.component.js
 **/